module.exports = __webpack_public_path__ + "social-icon.b79688f9ac3e2379f95c.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/node_modules/social-share-ng2/social-icon/font/social-icon.eot?16519986
// module id = ../../../../social-share-ng2/social-icon/font/social-icon.eot?16519986
// module chunks = styles